module.exports = __webpack_public_path__ + "media/pages/assets/images/folder-f9aa4733121b03a54741eba44a00cc5d.svg";